import PropTypes from "prop-types";

export default {
	id: PropTypes.string,
	type: PropTypes.oneOf(["left", "right", "bottom"]),
	animationTrigger: PropTypes.string,
};
